"use client";
import React from "react";
import Link from "next/link";
import getBlogs from "@/app/lib/getBlogs";
import { useState, useEffect } from "react";

export default function page({archives}) {
  // const [data, setData] = useState([]);

  useEffect(() => {

  }, []);

  return (
    <div>
      {" "}
      {/* archive section component */}
      {archives?.length > 12 && (
        <div className="bg-gradient-to-r from-[#9cc4c052] via-[#7d9db1] to-[#818187]">
          <div className="mx-20 max-md:mx-5 py-10 text-white">
            <div className="flex items-center max-md:items-start gap-2">
              <img
                src="/Images/save.png"
                alt="storyIcon"
                width={1000}
                height={1000}
                className="w-14"
              />
              <h1 className="text-[55px] max-sm:text-4xl text-[#011826] font-semibold poppins capitalize">
                From Archives
              </h1>
            </div>
            <Link href={"/viewAllBlogs"}>
              <button className="text-[#011826] text-lg capitalize m-auto mr-0 hover:underline flex items-center gap-2">
                see all
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="{1.5}"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                  />
                </svg>
              </button>
            </Link>
            {/* bottom movies */}
            <div className="flex justify-center gap-10 flex-wrap mt-10">
              {archives &&
                Array.isArray(archives) &&
                archives.length > 0 &&
                archives?.slice(12, 16)?.map((data, index) => (
                  <Link href={`/ReadBlog/${data?._id}`}>
                    {/* card : 1 */}
                    <div className="max-w-[400px]">
                      <img
                        src={data?.thumbnail}
                        alt=""
                        className=" m-auto block w-[396px] h-[256px]"
                      />
                      <h1 className="poppins capitalize text-center leading-tight mt-2 text-[16px] font-semibold">
                        {data?.category}
                      </h1>
                      <p className="text-[24px] font-medium poppins text-center">
                        {data?.title}
                      </p>
                      <p className="text-center uppercase font-[300] mt-1">
                        BY&nbsp;{data?.author}
                      </p>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
